export const AUTHENTICATION_TOKEN = 'AUTHENTICATION_TOKEN';
export const LOCAL_RETURN_URL_AFTER_LOGIN = 'LOCAL_RETURN_URL_AFTER_LOGIN';
export const POS_DEVICE_ID = 'POS_DEVICE_ID';
export const FILE_PREFIX_PATH = `${ process.env.REACT_APP_API_BASE_URL }/files`
export const DEFAULT_TAX_VALUE = 6.25
export const NOT_FOUND_MESSAGE = 'Not Found'

export const ITEM_NUMBERS_NOT_HAVING_EFFECTS = ['99999999', '0']